<template>
	<div class="data-table-container">
		<el-table
			ref="dataTable"
			:key="key"
			v-loading="loading"
			:data="tableData"
			:size="size"
			:height="inTableHeight"
			:border="border"
			:stripe="stripe"
			:header-cell-class-name="headerCellClass"
			:cell-class-name="cellClassName"
			:row-class-name="rowClassName"
			:row-key="rowKeys"
			:cell-style="cellStyle"
			:default-expand-all="defaultExpandAll"
			:empty-text="emptyText"
			class="data-table"
			:class="{ 'el-table-single': single }"
			v-bind="$attrs"
			v-on="$listeners"
			@select="handleSelect"
			@select-all="handleSelectAll"
			@selection-change="handleSelectChange"
			@row-click="handleRowClick"
			@sort-change="changeTableSort"
		>
			<el-table-column
				v-if="selection"
				type="selection"
				:reserve-selection="reserveSelection"
				width="50"
				align="center"
			></el-table-column>
			<el-table-column v-if="index" type="index" width="60" align="center" label="序号"></el-table-column>
			<el-table-column v-if="expand" type="expand" :width="expandWidth">
				<template slot-scope="scope">
					<slot :scope="scope" name="expand"></slot>
				</template>
			</el-table-column>
			<el-table-column
				v-for="(item, columnIndex) in column.filter(item => !item.isHidden)"
				:key="columnIndex"
				:label="item.label"
				:prop="item.prop"
				:sortable="item.sort"
				:min-width="item.minWidth"
				:width="item.width"
				:align="item.align || 'center'"
				:header-align="item.align || 'center'"
				:fixed="item.fixed"
				:show-overflow-tooltip="item.truncate"
			>
				<template slot-scope="scope">
					<slot v-if="item.slot" :scope="scope" :name="item.slot"></slot>
					<template v-else>{{ scope.row[item.prop] }}</template>
				</template>
			</el-table-column>

			<template slot="empty">
				<div class="empty-wrapper">
					<div class="empty-content">
						<img src="@/assets/noInfo.png" alt="暂无信息" />
						<p>暂无数据</p>
					</div>
				</div>
			</template>
		</el-table>

		<jr-pagination
			v-if="showPagination && pageOptions.total > pageOptions.limit"
			:limit="pageOptions.limit"
			:page.sync="pageOptions.page"
			:total="pageOptions.total"
			:hidden="pageHide"
			:page-sizes="pageOptions.pageSizes"
			layout="prev, pager, next"
			prev-text="上一页"
			next-text="下一页"
			@change="paginationChange"
		></jr-pagination>
	</div>
</template>

<script>
	// import { Loading } from 'element-ui' // 导入Loading指令
	import JrPagination from '@/components/Pagination'

	// 数据表格（样式与index不同）
	export default {
		name: 'DataTable',
		components: {
			JrPagination
		},
		// directives: {
		// 	loading: Loading.directive // 注册Loading指令
		// },
		props: {
			emptyText: {
				required: false,
				type: String,
				default: '暂无数据'
			},
			// 表格数据
			tableData: {
				required: true,
				type: Array,
				default: () => []
			},
			// 表头配置
			column: {
				required: false,
				type: Array,
				default: () => []
			},
			// 是否展示序号
			index: {
				required: false,
				type: Boolean,
				default: () => false
			},
			// 是否支持选择
			selection: {
				required: false,
				type: Boolean,
				default: () => false
			},
			// 是否在数据更新之后保留之前选中的数据（需指定 row-key）（即跨页选中数据）
			reserveSelection: {
				required: false,
				type: Boolean,
				default: () => false
			},
			// 是否支持下拉内容
			expand: {
				required: false,
				type: Boolean,
				default: () => false
			},
			// 是否默认展开所有行
			defaultExpandAll: {
				required: false,
				type: Boolean,
				default: () => false
			},
			// 展开行单元格宽度
			expandWidth: {
				required: false,
				type: Number,
				default: 50
			},
			// 展开行是否开启点击行展开行
			expandRowClick: {
				required: false,
				type: Boolean,
				default: () => false
			},
			// 是否仅支持单选
			single: {
				type: Boolean,
				required: false,
				default: false
			},
			// 是否显示加载
			loading: {
				type: Boolean,
				required: false
			},
			// 是否带有纵向边框
			border: {
				type: Boolean,
				required: false,
				default: true
			},
			// 是否为斑马纹 table
			stripe: {
				type: Boolean,
				required: false,
				default: false
			},
			// table尺寸，medium / small / mini
			size: {
				required: false,
				type: String,
				default: 'medium'
			},
			// 表格高度是否固定，或采用自适应高度
			fixedHeight: {
				required: false,
				type: Boolean,
				default: () => false
			},
			// 表格的高度，string/number
			height: {
				type: [Number, String, Function],
				default: () => null
			},
			// 表头行的 className 的回调方法，也可以使用字符串为所有表头行设置一个固定的 className。
			headerCellClass: {
				required: false,
				type: String,
				default: 'default-th'
			},
			// 单元格 className
			cellClassName: {
				type: String,
				required: false,
				default: 'default-cell'
			},
			// 行内的className
			rowClassName: {
				type: String,
				required: false,
				default: 'default-row'
			},
			cellStyle: {
				type: Function,
				required: false,
				default: null
			},
			/* 行内的rowKey */
			rowKeys: {
				type: Function,
				required: false,
				default: null
			},
			pageHide: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * 分页参数
			 * limit:每页显示的条数
			 * page:当前页码
			 * total:总条数
			 * pageSizes: 显示多少条集合
			 * hidden: 是否显示分页
			 */
			pageOptions: {
				type: Object,
				required: false,
				default() {
					return {
						limit: 10,
						page: 1,
						total: 0,
						pageSizes: [10, 20, 30, 50],
						hidden: false
					}
				}
			},
			/* 是否显示分页栏 */
			showPagination: {
				type: Boolean,
				required: false,
				default: true
			}
		},
		data() {
			return {
				key: Symbol(),
				multipleSelection: [],
				inTableHeight: null,
				pagination: {
					limit: 10,
					page: 1,
					total: 0,
					pageSizes: [10, 20, 30, 50],
					hidden: false
				}
			}
		},
		computed: {},
		watch: {
			/**
			 *  监听列表头变化 给table添加key
			 */
			column() {
				this.$nextTick(() => {
					this.key = Symbol()
				})
			}
		},
		created() {
			console.log('测试', this.loading)

			// 扩展配置，目的是引用组件不用把配置全写一遍
			this.pagination = Object.assign({}, this.pagination, this.pageOptions)
			// 该阶段可以接收父组件的传递参数
			this.inTableHeight = this.height
		},
		mounted() {},
		methods: {
			// 当用户手动勾选数据行的 Checkbox 时触发的事件
			handleSelect(selection, row) {
				this.$emit('selectEvent', { selection, row })
			},
			// 当选择项发生变化时会触发该事件
			handleSelectChange(rows) {
				if (this.single) {
					if (rows.length <= 0) {
						return
					} else if (rows.length === 1) {
						// console.log('当前选中的数据：');
						// console.log(rows);
					} else {
						const obj = rows[rows.length - 1] //取最后被选中的行
						rows = []
						rows[0] = obj
						this.multipleSelection = rows
						//先清空
						this.$refs.dataTable.clearSelection()
						//再赋值
						this.$refs.dataTable.toggleRowSelection(rows[0])
					}
					this.$emit('selectionChange', rows)
				} else {
					this.$emit('selectionChange', rows)
				}
			},
			// 当用户手动勾选全选 Checkbox 时触发的事件
			handleSelectAll(selection) {
				this.$emit('selectAll', selection)
			},
			// 翻页
			paginationChange(pager) {
				const { page, limit } = pager
				this.$emit('page-change', { page, limit })
			},
			// 点击一行
			handleRowClick(row, column, event) {
				if (this.expand && this.expandRowClick) {
					const $table = this.$refs.dataTable
					this.tableData.map(item => {
						if (row.id !== item.id) {
							$table.toggleRowExpansion(item, false)
						}
					})
					$table.toggleRowExpansion(row)
				}
				this.$emit('handleRowClick', row)
			},
			// 表格排序事件
			changeTableSort(column) {
				this.$emit('changeTableSort', column)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.data-table-container {
		.data-table {
			border: solid 1px #bad6f0;
		}

		::v-deep {
			.el-table {
				.el-table__cell {
					border-right: 1px solid #c8def3;
				}
				table {
					font-size: 16px;
				}
				// 默认表头样式
				.default-th {
					height: 50px;
					background: #dceaf7;
					color: #1f5d99;
					border-bottom: 1px solid #bad6f0;
				}

				.default-cell {
					border-bottom: 1px solid #bad6f0;
					padding: 13px 0px;
				}

				// 增加样式1，需从外部传递样式名称
				.th1 {
					height: 50px;
					background: #dceaf7;
					color: #1f5d99;
					border-bottom: 1px solid #bad6f0;
					font-size: 18px;
					font-weight: 500;
				}

				.cell1 {
					border-bottom: 1px solid #bad6f0;
					padding: 13px 0px;
					font-size: 16px;
					color: #333333;
				}

				// 当表格只能单选时，顶部全选按钮屏蔽
				&.el-table-single {
					.el-table__header-wrapper {
						.el-checkbox__inner {
							display: none !important;
						}
					}
				}
			}
		}
	}
</style>
